import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also attach Authorization header from localStorage as a fallback for
// environments where cross-site cookies are blocked.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("loot_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e) return "";
        if (typeof e.msg === "string") {
          // Pydantic v2 prepends "Value error, " / "String should match…" — clean those up.
          const field = (e.loc || []).filter((p) => p !== "body").pop();
          const prefix = field ? `${field}: ` : "";
          return prefix + e.msg.replace(/^Value error,\s*/i, "");
        }
        return JSON.stringify(e);
      })
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
